import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Custom Hook for fetching a players profile whenever the id changes
 *
 * @param {string} seasonId - The compseason id
 * @param {object} playerId - The player id
 * @returns {object} - Either the populated playerProfile object or an empty object
 */
export function usePlayerProfile(seasonId, playerId) {
    const dispatch = useDispatch();

    useEffect(() => {
        // Initialise the player profile in the redux store
        dispatch(
            PULSE.app.redux.actions.statsplayerprofile.ADD_PLAYER_PROFILE.request(
                {
                    seasonId,
                    playerId
                }
            )
        );
    }, [playerId]);

    const profile = useSelector((state) =>
        PULSE.app.redux.selectors.statsplayerprofile.item(state, playerId)
    );

    return playerId && profile ? profile : null;
}
